import { useContext } from "react";
import { UserReportContext } from "../../../context/UserReportContext";

export default function UserTestResultReportTableHooks() {
  const UserReportCxt = useContext(UserReportContext);

  const calculateTotalEarnedPointsPerLearningpath = (lp) => {
    const total = lp.modules.reduce((totalAcc, module) => {
      const modulePoints = module.test.reduce(
        (acc, curr) => acc + curr.pointsEarned,
        0
      );
      return totalAcc + modulePoints;
    }, 0);

    return total.toFixed(2); // keep toFixed only once at the end
  };


  const generateDataForUserTestResultReportTable = (data) => {
    const result = [];

    data.forEach((item) => {
      let lp = result.find((lp) => lp.lpId === item.lpId);

      if (!lp) {
        lp = { lpId: item.lpId, lpName: item.lpName, modules: [] };
        result.push(lp);
      }

      let module = lp.modules.find((m) => m.mName === item.mName);

      if (!module) {
        module = { mName: item.mName, test: [] };
        lp.modules.push(module);
      }

      module.test.push({
        id: item.id,
        name: item.name,
        score: item.score,
        libtype: item.libtype,
        viewTest:item.viewTest,
        lpId: item.lpId,
        lpcid: item.lpcid,
        orderno: item.orderno,
        weightage: item.weightage,
        pointsEarned: item.pointsEarned,
        assignedDate: item.assignedDate,
        mName: item.mName,
        mId: item.mId,
        tcId: item.tcId,
        qnid: item.qnid,
        topicid:item.topicid,
        topicname:item.topicname,
        duedate:item.duedate,
      });
    });

    UserReportCxt.setUserTestResultTableData(result);
  };

  return {
    generateDataForUserTestResultReportTable,
    calculateTotalEarnedPointsPerLearningpath,
  };
}
